import React from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import s from './performanceByStudentComponent.module.css';
import { AQUA_BASE } from '../../../reports-constants';
import { getAVGScoreColumn } from './componentFunctions';
import { roundtoTwoDecimals } from '../../../../util/util';
import { getConfigObject } from '../../../../util/config';
import { clickByStudent } from '../../../../analyticsEvents';
import { sortStudentsByName } from '../../../utils';
import EmailWithTooltip from '../../../../components/EmailTooltip/EmailWithTooltip';

import PaginatedTable from '../../../../../components/PaginatedTable/PaginatedTable';

const performanceByStudentComponent = (props) => {

  const { reportType, sendEvent } = props;

  const dispatch = useDispatch();

  const handleStudentClick = () => {
    dispatch(sendEvent(clickByStudent(reportType)));
  };
  const tableStyle = [
    {
      row: 'styledRow',
      cells: [
        { accessor: 'name', color: AQUA_BASE },
        { accessor: 'completedAssignments', alignment: 'right' },
        { accessor: 'averageCompletion', alignment: 'right' },
        { accessor: 'averageProficiency', alignment: 'right' },
      ],
    },
  ];

  const tag = "studentsListCard";
  const tableColumns = [
    {
      accessor: "lastName",
      Header: 'Student Name',
      cell: (item) => {
        if (getConfigObject().DASHBOARD_ENABLED_STUDENT_MODULE_REPORT) {
          return (
            <div>
              <button
                data-test-id={`${tag}-student-name`}
                className={s.clickable}
                onClick={() => {
                  props.onTabChange(item.reportUrl);
                  handleStudentClick();
                }}
              >
                {item.firstName} {item.lastName && <span className={s.studentLastName}>{item.lastName}</span>}
              </button>
              <br />
              <EmailWithTooltip email={item.email} className={s.studentEmail} />
            </div>
          );
        }
        return (
          <div>
            <span>{item.name}</span>
            <br />
            <EmailWithTooltip email={item.email} className={s.studentEmail} />
          </div>
        );
      },
    },
    {
      accessor: 'completedAssignments',
      Header: 'Assignments Completed',
      cell: (item) => {
        const formatedItem = item.completedAssignments === -1 ? '—' : `${item.completedAssignments}/${item.assignments}`;
        return formatedItem;
      },
    },
    {
      accessor: 'averageCompletion',
      Header: 'Achievement on Completion Assignments (Practice/Homework)',
      cell: (item) => {
        const formatedItem = item.averageCompletion === -1 ? '—' : `${roundtoTwoDecimals(item.averageCompletion)}%`;
        return formatedItem;
      },
    },
    {
      accessor: 'averageProficiency',
      Header: 'Achievement on Proficiency Assignments (Quizzes/Test)',
      cell: item => getAVGScoreColumn(item, 'averageProficiency'),
    },
  ];

  const nullStateContent = (
    <p>
      No students have enrolled in this course.<br />
      Go to the <button className={s.nullState} role="link" onClick={() => { props.onTabChange('people'); }}>People</button> tab to invite students to enroll.
    </p>
  );

  const data = props.data.map(student => ({
    ...student,
    assignments: props.assignments,
    reportUrl: props.buildReportUrl(student.studentId),
  }));

  const customSort = (students, direction) => sortStudentsByName(students, direction);

  return (
    <div className={s.performanceByStudents} data-test-id={`${reportType || 'overview'}-performance-by-student`}>
      <PaginatedTable
        id={tag}
        className={s.performanceCard}
        title="Performance by Student"
        data={data}
        tableStyle={tableStyle}
        tableColumns={tableColumns}
        sortBy={['averageProficiency', 'averageCompletion', 'name']}
        direction="asc"
        modalContent={props.modalContent}
        nullState={nullStateContent}
        styleFunction={() => 'styledRow'}
        reportType={reportType}
        customSort={customSort}
        customSortBy="lastName"
      />
    </div>
  );
};

performanceByStudentComponent.propTypes = {
  data: PropTypes.array,
  onTabChange: PropTypes.func,
  sendEvent: PropTypes.func,
  reportType: PropTypes.string,
  modalContent: PropTypes.object,
  buildReportUrl: PropTypes.func,
};

export default performanceByStudentComponent;
